/**
 * Klaviyo Form Trigger Handler
 * 
 * Handles click events on buttons that trigger Klaviyo form popups.
 * Listens for clicks on elements with the 'klaviyo-form-trigger' class
 * and opens the corresponding Klaviyo form using the form ID from data attribute.
 */

document.addEventListener('DOMContentLoaded', () => {
  console.log('[Klaviyo] Form trigger handler initialized');

  // Initialize Klaviyo onsite if not already initialized
  window._klOnsite = window._klOnsite || [];
  console.log('[Klaviyo] _klOnsite initialized:', window._klOnsite);

  // Add click handlers to all Klaviyo form trigger buttons
  const klaviyoTriggers = document.querySelectorAll('.klaviyo-form-trigger');
  console.log(`[Klaviyo] Found ${klaviyoTriggers.length} form trigger button(s)`);

  klaviyoTriggers.forEach((trigger, index) => {
    const formId = trigger.getAttribute('data-klaviyo-form-id');
    console.log(`[Klaviyo] Trigger ${index + 1}: Form ID = ${formId || 'MISSING'}`);

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      console.log(`[Klaviyo] Button clicked for form ID: ${formId}`);

      if (formId) {
        // Trigger Klaviyo form popup using their API
        console.log(`[Klaviyo] Calling window._klOnsite.push(['openForm', '${formId}'])`);
        window._klOnsite.push(['openForm', formId]);
        console.log('[Klaviyo] Form trigger command sent');
      } else {
        console.warn('[Klaviyo] Button missing data-klaviyo-form-id attribute');
      }
    });
  });
});

